import React from "react";
import CoreEngine from "../../core/CoreEngine";
import FormPage from "../../components/Form/FormPage";
import BranchServiceForm from "./BranchServiceForm";
import strings from "../../core/translate";

// Direct link version of the service dialog used on the services list.
export default class MerchantBranchServiceAddUpdate extends CoreEngine {
  getContext() {
    const routeState = this.props.location.state || {};
    const { selectedBranch } = this.props.match.params;
    return {
      selectedBranch: routeState.selectedBranch || selectedBranch,
      selectedMerchant: routeState.selectedMerchant,
      branchName: routeState.branchName,
    };
  }

  handleDone = () => {
    const { selectedBranch, selectedMerchant, branchName } = this.getContext();
    this.props.history.push({
      pathname: `/admin/merchants-branches/${selectedBranch}/services`,
      state: { selectedMerchant, selectedBranch, branchName },
    });
  };

  render() {
    const { selectedBranch, branchName } = this.getContext();
    const item = this.props.location.data;

    return (
      <FormPage
        title={
          item && item.id
            ? `${strings.edit} ${strings.service}`
            : `${strings.add} ${strings.service}`
        }
        subtitle={branchName}
      >
        <BranchServiceForm
          item={item}
          branchId={selectedBranch}
          onSaved={this.handleDone}
          onCancel={this.handleDone}
        />
      </FormPage>
    );
  }
}
